<template>
  <div class="mainbody">
    <!-- 顶部操作栏 -->
    <div style="padding: 16px 32px 16px 0px">
      <span class="title">团队</span>
      <div style="float: right">
        <el-button type="primary" size="small" @click="showCreateDialog">新增成员</el-button>
        <el-button type="success" size="small" @click="handleExport">导出列表</el-button>
      </div>
    </div>

    <!-- 搜索和筛选区域 -->
    <div style="padding: 16px 32px; background: #fafafa; margin-bottom: 16px;">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="搜索">
          <el-input
            v-model="searchForm.search"
            placeholder="请输入姓名/职务/电话/微信"
            clearable
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色">
          <el-select
            v-model="searchForm.screen_role"
            placeholder="请选择角色"
            clearable
          >
            <el-option
              v-for="item in roleList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 团队列表表格 -->
    <div class="tableInfo" style="margin: 0 32px;">
      <el-table
        :data="dataList"
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column prop="role_name" label="角色类型" width="120"></el-table-column>
        <el-table-column prop="name" label="姓名" width="120"></el-table-column>
        <el-table-column prop="position" label="职务" width="150"></el-table-column>
        <el-table-column prop="phone" label="电话" width="140"></el-table-column>
        <el-table-column prop="wechat" label="微信" width="140"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="150"></el-table-column>
        <el-table-column prop="update_time" label="最后更新时间" width="160"></el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        :key="elementui_page_key"
        class="elPagination"
        background
        layout="prev, pager, next"
        :page-size="pageMaxSize"
        :page-count="pageCount"
        :current-page="currentPage"
        @current-change="currentChange"
      ></el-pagination>
    </div>

    <!-- 新增成员弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="createDialogVisible"
      width="600px"
      :before-close="handleCloseCreateDialog"
    >
      <el-form :model="createForm" :rules="createRules" ref="createForm" label-width="100px">
        <el-form-item label="角色" prop="role">
          <el-select
            v-model="createForm.role"
            placeholder="请选择角色"
            style="width: 100%"
          >
            <el-option
              v-for="item in roleList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input
            v-model="createForm.name"
            placeholder="请输入姓名"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="职务" prop="position">
          <el-input
            v-model="createForm.position"
            placeholder="请输入职务"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input
            v-model="createForm.phone"
            placeholder="请输入电话"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="微信" prop="wechat">
          <el-input
            v-model="createForm.wechat"
            placeholder="请输入微信号"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="createForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseCreateDialog">取 消</el-button>
        <el-button type="primary" @click="handleCreate" :loading="createLoading">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 隐藏的导出表单 -->
    <form
      ref="exportForm"
      :action="exportUrl"
      method="POST"
      style="display: none;"
      target="_blank"
    >
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="association_id" :value="associationId" />
    </form>
  </div>
</template>

<script>
import * as Utils from "@/utils/utils.js";
import { LIST_PAGE_MAX_SIZE, URL_PATH } from "@/config/config";

export default {
  components: {},
  data() {
    return {
      loading: false,
      dataList: [],
      roleList: [],
      searchForm: {
        search: '',
        screen_role: ''
      },
      elementui_page_key: 0,
      pageCount: 0,
      pageMaxSize: 10,
      currentPage: 1,
      // 新增成员相关
      createDialogVisible: false,
      createLoading: false,
      isEdit: false,
      editId: null,
      createForm: {
        role: '',
        name: '',
        position: '',
        phone: '',
        wechat: '',
        remark: ''
      },
      createRules: {
        role: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.getRoleList();
    this.getList();
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑成员' : '新增成员';
    },
    exportUrl() {
      return URL_PATH + 'api/adminAppletsAssociationTeam/export';
    },
    token() {
      return localStorage.getItem('token');
    },
    associationId() {
      return this.$route.query.id;
    }
  },
  methods: {
    // 获取角色列表
    getRoleList() {
      this.$api
        .adminAppletsAssociationTeamRoleList({
          token: localStorage.getItem("token")
        })
        .then(({ data }) => {
          if (data && data.Data) {
            this.roleList = data.Data;
          }
        })
        .catch(({ error }) => {});
    },
    // 获取团队列表
    getList() {
      this.loading = true;
      this.$api
        .adminAppletsAssociationTeamList({
          token: localStorage.getItem("token"),
          association_id: this.$route.query.id,
          page: this.currentPage,
          limit: this.pageMaxSize,
          search: this.searchForm.search,
          screen_role: this.searchForm.screen_role
        })
        .then(({ data }) => {
          if (data && data.Data) {
            let current_page = Utils.listPage(data, this.currentPage);
            if (current_page) {
              this.currentPage = current_page;
              this.getList();
              return;
            }
            this.pageCount = data.Data.pageCount;
            this.dataList = data.Data.model || [];
          }
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    // 搜索
    handleSearch() {
      this.currentPage = 1;
      this.getList();
    },
    // 重置搜索
    resetSearch() {
      this.searchForm = {
        search: '',
        screen_role: ''
      };
      this.currentPage = 1;
      this.getList();
    },
    // 分页切换
    currentChange(val) {
      this.elementui_page_key++;
      this.currentPage = val;
      this.getList();
    },
    // 编辑
    handleEdit(row) {
      this.isEdit = true;
      this.editId = row.id;
      this.getMemberInfo(row.id);
    },
    // 获取成员详情
    getMemberInfo(id) {
      this.$api
        .adminAppletsAssociationTeamInfo({
          token: localStorage.getItem('token'),
          id: id
        })
        .then(({ data }) => {
          if (data && data.Data) {
            const info = data.Data;
            this.createForm = {
              role: info.role,
              name: info.name,
              position: info.position || '',
              phone: info.phone || '',
              wechat: info.wechat || '',
              remark: info.remark || ''
            };
            this.createDialogVisible = true;
          }
        })
        .catch(({ error }) => {});
    },
    // 删除
    handleDelete(row) {
      this.$confirm('是否删除此团队成员?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api
            .adminAppletsAssociationTeamDelete({
              token: localStorage.getItem('token'),
              id: row.id
            })
            .then(({ data }) => {
              if (data && data.Code === 0) {
                this.$message.success('删除成功');
                this.getList();
              }
            })
            .catch(({ error }) => {});
        })
        .catch(() => {});
    },
    // 显示新增弹窗
    showCreateDialog() {
      this.isEdit = false;
      this.editId = null;
      this.createDialogVisible = true;
      this.resetCreateForm();
    },
    // 关闭新增弹窗
    handleCloseCreateDialog() {
      this.createDialogVisible = false;
      this.isEdit = false;
      this.editId = null;
      this.resetCreateForm();
    },
    // 重置表单
    resetCreateForm() {
      this.createForm = {
        role: '',
        name: '',
        position: '',
        phone: '',
        wechat: '',
        remark: ''
      };
      if (this.$refs.createForm) {
        this.$refs.createForm.clearValidate();
      }
    },
    // 创建成员
    handleCreate() {
      this.$refs.createForm.validate((valid) => {
        if (valid) {
          this.createLoading = true;

          // 根据是新增还是编辑调用不同接口
          const apiMethod = this.isEdit
            ? 'adminAppletsAssociationTeamUpdate'
            : 'adminAppletsAssociationTeamCreate';

          const params = {
            token: localStorage.getItem('token'),
            role: this.createForm.role,
            name: this.createForm.name,
            position: this.createForm.position || '',
            phone: this.createForm.phone || '',
            wechat: this.createForm.wechat || '',
            remark: this.createForm.remark || ''
          };

          // 编辑时需要传id，新增时需要传association_id
          if (this.isEdit) {
            params.id = this.editId;
          } else {
            params.association_id = this.$route.query.id;
          }

          this.$api
            [apiMethod](params)
            .then(({ data }) => {
              if (data && data.Code === 0) {
                this.$message.success(this.isEdit ? '编辑成功' : '新增成功');
                this.handleCloseCreateDialog();
                this.getList();
              }
            })
            .catch(({ error }) => {})
            .finally(() => {
              this.createLoading = false;
            });
        }
      });
    },
    // 导出列表
    handleExport() {
      // 使用表单提交方式导出
      this.$refs.exportForm.submit();
    }
  }
};
</script>

<style lang="less" scoped>
.mainbody {
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-top: 16px;
}
.elPagination {
  margin-top: 16px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/association/associationTeam.vue